import React from "react";

function HeaderNavItemContext({ icon, name, description, badge }) {
  return (
    <div className="flex flex-row items-center gap-3 select-none">
      {icon && <div className="text-xl local-theme-text-md">{icon}</div>}
      <div>
        {name && <div className="text-md local-theme-text-md">{name}</div>}
        {description && (
          <div className="text-xs local-theme-text-sm">
            {description}
          </div>
        )}
      </div>
      {badge && <div>{badge}</div>}
    </div>
  );
}

export default HeaderNavItemContext;
